import React from 'react';
import { Box, Typography, Container, Link } from '@mui/material';
import { useSearchParams } from 'react-router-dom';

const Subscribe = () => {
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email');
    const token = searchParams.get('token');

    return (
        <Container maxWidth="sm">
            <Box
                sx={{
                    minHeight: '60vh',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center',
                    py: 8
                }}
            >
                <Typography
                    variant="h3"
                    sx={{
                        mb: 6,
                        fontWeight: 300,
                        letterSpacing: '2px',
                        fontSize: { xs: '32px', md: '48px' }
                    }}
                >
                    <span style={{ fontFamily: '"Playfair Display", serif' }}>DAINASOUL</span>{' '}
                    <span style={{ fontFamily: 'sans-serif', fontWeight: 300 }}>Collection</span>
                </Typography>
                
                <Typography
                    variant="body1"
                    sx={{
                        color: '#555',
                        mb: 1.5,
                        lineHeight: 1.6,
                        fontSize: '15px'
                    }}
                >
                    Thank you for subscribing to our mailing list.
                </Typography>
                
                <Typography
                    variant="body1"
                    sx={{
                        color: '#555',
                        mb: 3,
                        lineHeight: 1.6,
                        fontSize: '15px'
                    }}
                >
                    You can unsubscribe at any time.
                </Typography>

                <Link
                    href={`/account/unsubscribe?email=${encodeURIComponent(email)}&token=${token}`}
                    sx={{
                        color: '#000',
                        textDecoration: 'none',
                        fontSize: '11px',
                        letterSpacing: '2px',
                        fontWeight: 500,
                        borderBottom: '1px solid #000',
                        pb: 0.5,
                        textTransform: 'uppercase',
                        '&:hover': {
                            color: '#666',
                            borderColor: '#666'
                        }
                    }}
                >
                    UNSUBSCRIBE
                </Link>
            </Box>
        </Container>
    );
};

export default Subscribe;
